import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { BehaviorSubject, Subject } from 'rxjs';
import { AppConfiguration } from '../models/app-configuration';
import { Client } from '../models/client';
import { Matter } from '../models/matter';
import { DataService } from './data.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    private shift: number = 3;

    public roleSubjectChanged = new BehaviorSubject<boolean>(false);

    entityMatterFromUrl: Subject<{ entity: string, matter: string }>
        = new Subject<{ entity: string, matter: string }>();

    selectedEntityAndMatterChanged: Subject<{ action: string, selectedEntity: Client | undefined, selectedMatter: Matter | undefined }>
        = new Subject<{ action: string, selectedEntity: Client | undefined, selectedMatter: Matter | undefined }>();

    public appConfig!: AppConfiguration | undefined;

    dateFormat: string = "";

    constructor(
        private http: HttpClient,
        private dataService: DataService,
        private dialog: MatDialog
    ) {}

    async loadAppConfig() {
        this.appConfig = await this.dataService.get<AppConfiguration>('api/configurations');
    }

    getDialogConfig(): MatDialogConfig {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.width = '1050px';
        dialogConfig.height = 'auto';
        dialogConfig.autoFocus = true;
        return dialogConfig;
    }

    encrypt(text: string): string {
        return this.shiftText(text, this.shift);
    }

    decrypt(text: string): string {
        return this.shiftText(text, -this.shift);
    }

    private shiftText(text: string, shift: number): string {
        let result = '';
        for (let i = 0; i < text.length; i++) {
            const char = text.charCodeAt(i);

            if (char >= 65 && char <= 90) {
                result += String.fromCharCode(((char - 65 + shift + 26) % 26) + 65);
            } else if (char >= 97 && char <= 122) {
                result += String.fromCharCode(((char - 97 + shift + 26) % 26) + 97);
            } else if (char >= 48 && char <= 57) {
                result += String.fromCharCode(((char - 48 + shift + 10) % 10) + 48);
            } else {
                result += String.fromCharCode(char);
            }
        }
        return result;
    }

    formatNumberWithoutRounding(value:number):string {
        if (isNaN(value)) {
            return "0.00";
        }else{
            const [whole, fractional = ''] = value.toString().split('.');
            const truncatedFractional = fractional.slice(0, 2);
            const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return `${formattedWhole}.${truncatedFractional.padEnd(2, '0')}`;
        }
    }

    parseFormattedNumber(value: string | number | null | undefined): number | undefined {
        if (value === null || value === undefined || value === '') {
            return undefined;
        }
        const cleaned = Number(String(value).replace(/,/g, ''));
        return isNaN(cleaned) ? undefined : cleaned;
    }

    async getEncryptedTenant(){
        var tenantId = localStorage.getItem("tenantId")!
        var webHookUrl = await this.dataService.get<AppConfiguration>('api/configuration/tenant/' + this.decrypt(tenantId));
        return webHookUrl.partner.webHookUrl
    }

    apiSecurityError() {
        var configConnectionError = {
            title: 'ActionStep Connection Error',
            message: 'Unable to connect to the ActionStep API. Please login again.',
            dialogType: 'critical',
            buttonType: 'OkOnly',
            confirmText: 'Login',
            cancelText: 'Cancel',
        }
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: configConnectionError,
            width: '30%',
        });

        dialogRef.afterClosed().subscribe(res => {
            if (res) {
                this.logOut();
            }
        })
    }

    logOut() {
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem('LOGOUT', Date.now().toString());
        window.location.reload();
    }

    convertUtcToLocal(dateToConvert: string | Date): Date {
        if (!dateToConvert) return new Date(1, 0, 1);

        let date: Date;
        if (dateToConvert instanceof Date) {
            date = dateToConvert;
        } else {
            const utcString = dateToConvert.endsWith('Z') ? dateToConvert : dateToConvert + 'Z';
            date = new Date(utcString);
        }

        if (isNaN(date.getTime())) {
            console.error("Invalid date format:", dateToConvert);
            return new Date(1, 0, 1);
        }

        return date;
    }





}
